import ProfilePage from "../components/mention-profile/main";


function MentionProfile() {
  return (
    <div>
      <ProfilePage />
    </div>
  );
}

export default MentionProfile;
